<template>
  <g>
    <component :is="gridWrapper">
      <g v-if="xGridVisible" v-axis:props="xGridAxisProps" :transform="xGridTransform" />

      <g v-if="yGridVisible" v-axis:props="yGridAxisProps" :transform="yGridTransform" />
    </component>

    <component :is="axesWrapper">
      <top-axis
        v-if="topAxisVisible"
        :x="0"
        :y="y"
        :scale="xScale"
        :space="topAxisSpace"
        :custom="topAxisCustom"
        :setSpace="setSpace"
      />
      <right-axis
        v-if="rightAxisVisible"
        :x="x + width"
        :y="0"
        :scale="yScale"
        :space="rightAxisSpace"
        :custom="rightAxisCustom"
        :setSpace="setSpace"
      />
      <bottom-axis
        v-if="bottomAxisVisible"
        :x="0"
        :y="y + height"
        :scale="xScale"
        :space="bottomAxisSpace"
        :custom="bottomAxisCustom"
        :setSpace="setSpace"
      />
      <left-axis
        v-if="leftAxisVisible"
        :x="x - 20"
        :y="0"
        :scale="yScale"
        :space="leftAxisSpace"
        :custom="leftAxisCustom"
        :setSpace="setSpace"
        class="left-axis"
      />
    </component>
  </g>
</template>

<script>
import { axisBottom, axisRight } from 'd3-axis';
import TopAxis from './topAxis.component';
import BottomAxis from './bottomAxis.component';
import RightAxis from './rightAxis.component';
import LeftAxis from './leftAxis.component';
import { axis } from './axes.directives';
import { ChartAxesMixin } from './axes.mixins';

export default {
  mixins: [ChartAxesMixin],
  props: {
    xScale: { type: Function },
    yScale: { type: Function },
    width: { type: Number },
    height: { type: Number },
    x: { type: Number },
    y: { type: Number },
    setSpace: { type: Function },
  },
  components: { TopAxis, BottomAxis, RightAxis, LeftAxis },
  directives: { axis },
  computed: {
    xGridAxisProps() {
      const axisScale = axisBottom(this.xScale)
        .tickSize(this.height)
        .tickFormat('');
      return { axisScale, custom: this.xGridCustom };
    },
    yGridAxisProps() {
      const axisScale = axisRight(this.yScale)
        .ticks(5)
        .tickSize(this.width)
        .tickFormat('');
      return { axisScale, custom: this.yGridCustom };
    },
    xGridTransform() {
      return `translate(0, ${this.y})`;
    },
    yGridTransform() {
      return `translate(${this.x}, 0)`;
    },
  },
};
</script>
